import { debug } from "../../utils";

export const ACTION_CONFIGCHANGERESULT_TYPES_CHANGED = "ACTION_CONFIGCHANGERESULT_TYPES_CHANGED";
export const ACTION_CONFIGCHANGESRESULT_CHANGED = "ACTION_CONFIGCHANGESRESULT_CHANGED";
export const ACTION_SELECTED_CONFIGCHANGE_CHANGED = "ACTION_SELECTED_CONFIGCHANGE_CHANGED";


export function ConfigChangesPageReducer(state = {}, action) {
    switch (action.type) {
        case ACTION_CONFIGCHANGERESULT_TYPES_CHANGED: {
            debug(`ConfigChangesPageReducer ${ACTION_CONFIGCHANGERESULT_TYPES_CHANGED} is being processed...`)
            return { ...state, ...action.payload };
        }
        case ACTION_CONFIGCHANGESRESULT_CHANGED: {
            debug(`ConfigChangesPageReducer ${ACTION_CONFIGCHANGESRESULT_CHANGED} is being processed...`)
            return { ...state, ...action.payload };
        }
        case ACTION_SELECTED_CONFIGCHANGE_CHANGED: {
            debug(`ConfigChangesPageReducer ${ACTION_SELECTED_CONFIGCHANGE_CHANGED} is being processed...`)
            return { ...state, ...action.payload };
        }
        default:
            return state;
    }
}